import { ConfigProvider, Alert } from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

import { BillingStatusBanner } from '@app/components/BillingStatusBanner';
import { ServerMaintenanceBanner } from '@app/components/ServerMaintenanceBanner';
import { PREFIX } from '@app/constants';
import { useInitNewUserAccessRights } from '@app/hooks';
import { NotificationProvider, LeavePageProvider } from '@app/providers';
import { CheckNetworkProvider } from '@app/providers/CheckNetworkProvider/CheckNetworkProvider';
import { ConfirmProvider } from '@app/providers/ConfirmProvider/ConfirmProvider.main';
import { NewConfirmProvider } from '@app/providers/NewConfirmProvider/NewConfirmProvider.main';
import { router } from '@app/routes/router';
import { setAxiosConfig } from '@app/services';
import { checkAppVersionAndClearSessionStorage } from '@app/utils/checkAppVersionAndClearSessionStorage';

import '@app/utils/fontAwesomeIconsLibrary';

import 'dayjs/locale/ru';
import '@app/styles/App.desktop.scss';
import '@app/styles/App.tablet.scss';
import '@app/styles/App.mobile.scss';
const { ErrorBoundary } = Alert;

dayjs.locale('ru');
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

setAxiosConfig();

export const App = () => {
  useEffect(() => {
    checkAppVersionAndClearSessionStorage();
  }, []);

  useInitNewUserAccessRights();

  return (
    <ErrorBoundary
      message="Что-то пошло не так"
      description="Попробуйте перезагрузить страницу или зайдите позже."
    >
      <ConfigProvider
        locale={ru_RU}
        theme={{
          components: {
            Tooltip: {
              colorBgSpotlight: '#fff',
              colorTextLightSolid: '#000',
            },
          },
        }}
      >
        <NewConfirmProvider>
          <ConfirmProvider>
            <LeavePageProvider>
              <CheckNetworkProvider>
                <NotificationProvider>
                  <>
                    <ServerMaintenanceBanner />
                    <BillingStatusBanner />
                    <div className={`${PREFIX}app`}>
                      <RouterProvider
                        router={router}
                        future={{ v7_startTransition: true }}
                      />
                    </div>
                  </>
                </NotificationProvider>
              </CheckNetworkProvider>
            </LeavePageProvider>
          </ConfirmProvider>
        </NewConfirmProvider>
      </ConfigProvider>
    </ErrorBoundary>
  );
};
